module.exports = __webpack_public_path__ + "media/components/app-store/static/s7-2742bd68d03f2df6c1bee43e8c46c9c4.jpg";